import React from "react";

// eslint-disable-next-line import/no-anonymous-default-export
export default () => {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="System_&#38;_Status/Fill/Warning">
        <path
          id="Shape"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M32.1251 9.80349C30.3722 6.49256 25.6292 6.49258 23.8764 9.80349L6.75185 42.1499C5.10643 45.2579 7.35951 49 10.8762 49H45.1253C48.642 49 50.8951 45.2579 49.2496 42.1499L32.1251 9.80349ZM28.0007 21C26.712 21 25.6673 22.0447 25.6673 23.3333V32.6667C25.6673 33.9553 26.712 35 28.0007 35C29.2893 35 30.334 33.9553 30.334 32.6667V23.3333C30.334 22.0447 29.2893 21 28.0007 21ZM28.0007 42C29.2893 42 30.334 40.9553 30.334 39.6667C30.334 38.378 29.2893 37.3333 28.0007 37.3333C26.712 37.3333 25.6673 38.378 25.6673 39.6667C25.6673 40.9553 26.712 42 28.0007 42Z"
          fill="#FFAB00"
        />
      </g>
    </svg>
  );
};
